import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/Layout';
import { useTranslation } from 'react-i18next';
import { ConfigProvider, DatePicker } from 'antd';
import { PointsService } from '../api/services/PointsService';
import locale from 'antd/locale/es_ES';
import dayjs from 'dayjs';

// import 'dayjs/locale/es-ES';

// dayjs.locale('es-ES');
const RechargeRecord: React.FC = () => {
	const { t } = useTranslation();
	const [dataList, setDataList] = useState<any>([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [searchDate, setSearchDate] = useState<any>(null);
	const getStatusStyle = (status: number) => {
		switch (status) {
			case 2:
				return 'bg-green-100 text-green-700';
			case 1:
				return 'bg-amber-100 text-amber-700';
			case 3:
				return 'bg-red-100 text-red-700';
			default:
				return 'bg-gray-100 text-gray-700';
		}
	};
	const statusTextOptions = {
		1: t('recharge.pending'),
		2: t('recharge.completed'),
		3: t('recharge.rejected'),
		4: t('recharge.rejected'),
	};
	const getList = async (params: any) => {
		if (params.page === 0) {
			setDataList([]); // 直接清空
		}
		try {
			const res = await PointsService.getRechargeRecords(params);
			if (res) {
				if (params.isChange) {
					setDataList(res?.data);
				} else {
					setDataList((prev: any) => [...prev, ...res?.data]);
				}
				setTotal(res?.pageInfo?.total);
			}
		} catch (err) {}
	};
	useEffect(() => {
		getList({ page: 0, pageSize: 10, date: searchDate, isChange: false });
	}, []);
	return (
		<Layout title={t('rechargeRecord.title')} showBack={true}>
			<div className="min-h-screen bg-gray-50 py-2 px-2">
				<div className="mx-2 mt-2 bg-white">
					{/* <div className="text-gray-500 text-sm mt-1 px-2 py-1">
						<p>{t('rechargeRecord.totalPoints')}</p>
					</div>
					<h2 className="text-xl font-bold px-2 py-1 mb-1">{}</h2> */}
					<div className="px-2 py-1">
						<ConfigProvider locale={locale}>
							<DatePicker
								onChange={(date, dateString) => {
									getList({ page: 0, pageSize: 10, date: dateString, isChange: true });
									setPage(0);
								}}
								allowClear
								placeholder={t('rechargeRecord.selectMonth')}
								picker="month"
							></DatePicker>
						</ConfigProvider>
					</div>
					<div className="px-2 py-1 mt-1">
						{dataList.map((item: any) => (
							<div key={item.id} className="p-3 bg-gray-50 rounded-lg mb-2">
								<div className="flex items-center justify-between mb-1">
									<span className="font-semibold text-gray-900">
										+{item.points?.toLocaleString() || 0}
										{t('recharge.points')}
									</span>
									<span
										className={`px-2.5 py-0.5 text-xs rounded-full font-medium ${getStatusStyle(
											item.status
										)}`}
									>
										{statusTextOptions[item.status as keyof typeof statusTextOptions]}
									</span>
								</div>
								<p className="text-sm text-gray-500">
									{t('recharge.agent')}：{item.merchant?.name} | {item.createdAt}
								</p>
								{item.rejectReason && (
									<p className="text-xs text-red-600 mt-1">
										{t('recharge.rejectReason')}：{item.rejectRemark}
									</p>
								)}
								{item.note && (
									<p className="text-xs text-gray-600 mt-1">
										{t('recharge.remarkPrefix', { note: item.note })}
									</p>
								)}
							</div>
						))}
						{total > dataList?.length ? (
							<div className="flex justify-center py-12">
								<button
									className="w-full bg-white text-gray-500 border border-blue-500 py-3 rounded-lg font-semibold mt-6"
									onClick={() => {
										const pages = page + 1;
										setPage(pages);
										getList({
											page: pages,
											pageSize: 10,
											date: searchDate,
											isChange: false,
										});
									}}
								>
									{t('myNumbers.loadMore')}
								</button>
							</div>
						) : null}
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default RechargeRecord;
